import { c as _c } from "react-compiler-runtime";
/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from "react";
export function useSuccessSpinnerState(state) {
  const $ = _c(6);
  const [renderState, setRenderState] = useState(state);
  const [startAnimation, setStartAnimation] = useState(false);
  let t0;
  let t1;
  if ($[0] !== state) {
    t0 = () => {
      setStartAnimation(false);
      if (state === "loading" || state === "error") {
        setRenderState(state);
        return;
      }
      setStartAnimation(true);
      const newTimer = setTimeout(() => {
        setRenderState("success");
        setStartAnimation(false);
      }, 3000);
      return () => {
        clearTimeout(newTimer);
      };
    };
    t1 = [state];
    $[0] = state;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== renderState || $[4] !== startAnimation) {
    t2 = {
      renderState,
      startAnimation
    };
    $[3] = renderState;
    $[4] = startAnimation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
//# sourceMappingURL=useSuccessSpinnerState.js.map